import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import Pagination from "react-js-pagination";
import Modal from "react-bootstrap/Modal";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import { Url } from "../../config/config";

export default function BlogList() {
  const [record, setRecord] = useState([]);
  const [total, setTotal] = useState(0);
  const [activePage, setActivePage] = useState(1);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [deleteId, setDeleteId] = useState("");

  // Delete modal
  const [DeleteModal, setDeleteModal] = useState(false);
  const handelDeleteShow = (id) => {
    setDeleteModal(true);
    setDeleteId(id);
  };
  const handelDeleteClose = () => {
    setDeleteModal(false);
    setDeleteId("");
  };

  const handelDelete = async () => {
    try {
      const res = await axios({
        url: `${Url}/blog/delete/${deleteId}`,
        method: "DELETE",
      });
      if (res.data.status === 200) {
        handelDeleteClose();
        toast.success(res.data.message);
        blogList(activePage);
      } else {
        toast.error("Something went wrong");
      }
    } catch (err) {
      console.log(err);
    }
  };

  // Status modal
  const [BlockModal, setBlockModal] = useState(false);
  const [statusData, setStatusData] = useState({ id: "", status: false });

  const handelBlockClose = () => {
    setBlockModal(false);
  };

  const handleChecked = (e, id) => {
    setBlockModal(true);
    setStatusData({ id: id, status: e.target.checked });
  };

  const handelUpdateStatus = async () => {
    try {
      const res = await axios({
        url: `${Url}/blog/change_status`,
        method: "POST",
        data: {
          id: statusData.id,
          status: statusData.status,
        },
      });
      if (res.data.status === 200) {
        handelBlockClose();
        toast.success(res.data.message);
        blogList(activePage);
      } else {
        toast.error("Something went wrong");
      }
    } catch (err) {
      console.log(err);
    }
  };

  // Fetch blog list
  const blogList = async (page = 1, query = "") => {
    try {
      showLoader();
      const res = await axios({
        url: `${Url}/blog/list?page=${page}&search=${query}`,
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });
      hideLoader();
      if (res.data.status === 200) {
        setRecord(res.data.data.blogList);
        setTotal(res.data.data.total);
      }
    } catch (err) {
      console.log(err);
      hideLoader();
    }
  };

  useEffect(() => {
    blogList(activePage);
    // eslint-disable-next-line
  }, []);

  const handelSearch = (e) => {
    blogList(activePage, e.target.value);
  };

  const handlePageChange = (pageNo) => {
    setActivePage(pageNo);
    blogList(pageNo);
  };

  var count = (activePage - 1) * 10 + 1;

  return (
    <React.Fragment>
      <title>Blog Management</title>
      <div className="WrapperArea">
        <div className="WrapperBox">
          <div className="Small-Wrapper">
            <div className="SearchBox">
              <input
                type="text"
                placeholder="Search .."
                onChange={handelSearch}
              />
              <Link to="/blogs/add" className="button py-auto">
                Add&nbsp;Blog
              </Link>
            </div>
            <h4 className="Title">Blog Management</h4>
            {loader}
            <div className="TableList">
              <table>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Image</th>
                    <th>Title</th>
                    <th>Author</th>
                    <th>Featured</th>
                    <th>Status</th>
                    <th>Created Date</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {record &&
                    record.length > 0 &&
                    record.map((item, i) => (
                      <tr key={i}>
                        <td>{count++}</td>
                        <td>
                          {item.image ? (
                            <img
                              src={item.image}
                              height="50"
                              width="50"
                              alt={item.title}
                              style={{ objectFit: "cover" }}
                            />
                          ) : (
                            ""
                          )}
                        </td>
                        <td>{item.title}</td>
                        <td>{item.author}</td>
                        <td>
                          {item.isFeatured ? (
                            <span className="badge bg-success">Featured</span>
                          ) : (
                            <span className="badge bg-secondary">No</span>
                          )}
                        </td>
                        <td>
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              name="status"
                              checked={item.status}
                              onChange={(e) => handleChecked(e, item._id)}
                            />
                            <label className="form-check-label"></label>
                          </div>
                        </td>
                        <td>
                          {new Date(item.createdAt).toLocaleDateString("en-GB")}
                        </td>
                        <td>
                          <Link
                            to={`/blogs/edit/${item._id}`}
                            className="Green inline-block"
                          >
                            <i className="fa fa-edit"></i>
                          </Link>
                          <span
                            className="Red inline-block"
                            onClick={() => handelDeleteShow(item._id)}
                          >
                            <i className="fa fa-trash"></i>
                          </span>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
            {total > 10 ? (
              <div className="Pagination">
                <Pagination
                  activePage={activePage}
                  previousLabel={"previous"}
                  nextLabel={"next"}
                  itemsCountPerPage={10}
                  totalItemsCount={total}
                  pageRangeDisplayed={5}
                  onChange={handlePageChange}
                />
              </div>
            ) : null}
          </div>
        </div>
      </div>

      <div className="ModalBox">
        {/* Delete Modal */}
        <Modal show={DeleteModal} onHide={handelDeleteClose}>
          <Modal.Header closeButton onClick={handelDeleteClose}>
            <Modal.Title>Delete</Modal.Title>
          </Modal.Header>
          <Modal.Body>Are you sure you want to delete this blog?</Modal.Body>
          <Modal.Footer>
            <button
              className="primary"
              variant="secondary"
              onClick={handelDeleteClose}
            >
              No
            </button>
            <button
              className="secondary"
              variant="primary"
              onClick={handelDelete}
            >
              Yes
            </button>
          </Modal.Footer>
        </Modal>

        {/* Status Modal */}
        <Modal show={BlockModal} onHide={handelBlockClose}>
          <Modal.Header closeButton onClick={handelBlockClose}>
            <Modal.Title>Change Status</Modal.Title>
          </Modal.Header>
          <Modal.Body>Are you sure you want to change the status?</Modal.Body>
          <Modal.Footer>
            <button
              className="secondary"
              variant="secondary"
              onClick={handelBlockClose}
            >
              No
            </button>
            <button
              className="primary"
              variant="primary"
              onClick={handelUpdateStatus}
            >
              Yes
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    </React.Fragment>
  );
}
